import { Box } from "@mui/material";
import Button, { ButtonProps } from "@mui/material/Button";
import Progress from "@mui/material/CircularProgress";
import { useEffect, useRef, useState } from "react";

interface LoadingButtonBaseProps {
  loading?: boolean;
  indicatorSize?: number;
  children: React.ReactNode;
}

export type LoadingButtonProps = ButtonProps & LoadingButtonBaseProps;
const LoadingButton: React.FC<LoadingButtonProps> = ({
  children,
  loading = false,
  indicatorSize = 22,
  ...rest
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [buttonWidth, setButtonWidth] = useState<number | undefined>(undefined);

  // Capture the button width on initial render and when children change
  useEffect(() => {
    if (buttonRef.current && !buttonWidth) {
      // Add a small buffer to prevent text wrapping
      setButtonWidth(buttonRef.current.offsetWidth + 2);
    }
  }, [children, buttonRef, buttonWidth]);

  return (
    <Button
      ref={buttonRef}
      disabled={loading || rest.disabled}
      style={{ minWidth: buttonWidth ? `${buttonWidth}px` : undefined }}
      {...rest}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Progress size={indicatorSize} sx={{ color: "white", my: loading && 0.2 }} />
        </Box>
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
